import React from 'react';
import FormField from 'scy/FormField';
import { validPhone } from 'shared/models/address';

const fallbackValidator = {
  parse: phoneNumber => phoneNumber,
  isValidNumber: validPhone
};

export default class PhoneInput extends React.Component {
  state = {
    loading: false,
    phoneNumber: ''
  };

  validator = fallbackValidator;

  componentDidMount() {
    this.loadValidator();
    if (this.props.forwardValidator) {
      this.props.forwardValidator(phoneNumber => this.validate(phoneNumber));
    }
  }

  loadValidator() {
    this.setState({ loading: true });

    import('google-libphonenumber')
      .then(module => {
        this.validator = module.PhoneNumberUtil.getInstance();
        this.PHONE_FORMAT = module.PhoneNumberFormat.INTERNATIONAL;
        const currentPhoneNumber =
          this.state.phoneNumber || this.props.initialValue;
        if (currentPhoneNumber) this.handleChange(currentPhoneNumber);
        this.setState({ loading: false });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  }

  handleChange(input) {
    const phoneNumber = this.format(input);
    this.setState({ phoneNumber });
    if (this.props.onChange) this.props.onChange(phoneNumber);
  }

  format(phoneNumber) {
    let result = phoneNumber;
    try {
      const parsed = this.validator.parse(phoneNumber, 'US');
      result = this.validator.format(parsed, this.PHONE_FORMAT);
    } catch (e) {
      // ignore
    }
    return result;
  }

  validate(phoneNumber) {
    const errorMessage =
      this.props.notValidMessage || 'Mobile number is not valid';

    let number;
    try {
      number = this.validator.parse(phoneNumber, 'US');
    } catch (e) {
      return errorMessage;
    }

    if (!this.validator.isValidNumber(number)) return errorMessage;
  }

  render() {
    const { id, name, labelText, initialValue, error, disabled } = this.props;

    return (
      <FormField
        disabled={disabled || this.state.loading}
        id={id || 'user-mobile'}
        name={name || 'phone'}
        labelText={labelText || 'Mobile No.'}
        inputType="tel"
        autocomplete="mobile tel"
        initialValue={initialValue ? this.format(initialValue) : ''}
        updatedValue={this.state.phoneNumber}
        onChange={phoneNumber => this.handleChange(phoneNumber)}
        validate={phoneNumber => this.validate(phoneNumber)}
        error={error}
      />
    );
  }
}
